import { Fancybox } from "@fancyapps/ui";

Fancybox.bind("[data-fancybox]", {
  Images: {
    protected: true,
  },
});

Fancybox.bind("[data-fancybox-no-zoom]", {
  Images: {
    protected: true,
    Panzoom: {
      zoom: false
    },
  },
});
